//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, minLength, maxLength, helpers } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";
import config from "@/config";
import errorTags from "@/ErrorTags";
import addMatchNumber from "@/components/matchNumber/addMatchNumber.vue";
import editMatchNumber from "@/components/matchNumber/editMatchNumber.vue";
import deleteMatchNumber from "@/components/matchNumber/deleteMatchNumber.vue";
import moment from 'moment'
import { date } from 'quasar'

const containDate = helpers.regex("containAlphaNum", /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/);

export default {
  components: {
    ValidateResult,
    addMatchNumber,
    editMatchNumber,
    deleteMatchNumber
  },
  data () {
    return {
      dpMatchDate: new Date().toISOString().slice(0,10),
      ddlCompanyList: null,
      // txtFilterDataTableList: "",

      dtMatchDate: null,

      strColor: "orange",
      strTableSeparators: 'cell',
      blnDense: true,
      blnDenseOptions: true,
      blnLoading: false,
      blnButtonDisable: true,
      blnDropDownListDisable: true,
      blnDropDownListReadOnly: true,
      blnMatchDateAutoFocus: true,
      blnCompanyListAutoFocus: false,

      strMaskTextBox:'####-##-##',
      strMaskDatePicker: "YYYY-MM-DD",

      aryData: [],
      aryAPIData: [],
      aryVisibleColumns: [ 'match_date', 'match_id', 'red_num', 'pool', 'bet_amount', 'created_on', 'updated_on', 'updated_by', 'action' ],
      aryColumns: [
        { name: 'match_date', label: 'Match Date', field: '', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'match_id', label: 'Company Name', field: 'match_id', align: 'center', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'red_num', label: 'Number', field: 'red_num', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'pool', label: 'Pool', field: 'pool', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'bet_amount', label: 'Bet Amount', field: 'bet_amount', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'created_on', label: 'Created On', field: 'created_on', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'updated_on', label: 'Updated On', field: 'updated_on', align: 'right', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'updated_by', label: 'Updated By', field: 'updated_by', align: 'center', sortable: false, headerClasses: 'bg-primary text-white' },
        { name: 'action', label: 'action', field: '', align: 'center', sortable: false, headerClasses: 'bg-primary text-white' },
      ],
      strRowKey: "red_num",

      dicPagination: {
        sortBy: 'red_num',
        descending: false,
        page: 1,
        rowsPerPage: config.aryPageSizeList[0],
        rowsNumber: 0
      },

      aryOptionsPageSizeList: config.aryPageSizeList,
      aryCompanyList: [],
      aryOptionsCompanyList: null,

      blnShowMessage: false,
      strBannerClass: "",
      strBannerMessage: "",

      blnDialogAdd: false,
      blnDialogEdit: false,
      blnDialogDelete: false,

      dataCompanyName: {},
      dataRedNumber: "",
      dataPool: "",

      jsonResponse: {
        success: true,
        status: ""
      }
    }
  },
  validations: {
    dpMatchDate: {
      required,
      containDate,
      minLength: minLength(10),
      maxLength: maxLength(10)
    },
    // ddlCompanyList: {
    //   required
    // }
  },
  methods: {
    fcValidationDate (strValue) {
      return date.isValid(strValue) || "Invalid Date.";
    },
    fcMatchDateAutoClose () {
      this.$refs.puDatePicker.hide();
    },
    fcSearch () {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let apiURL = config.matchNumberLookupByDate_Url();

				var jsonRequest = {
					session_token: this.$store.getters.sessionToken,
					user_id: this.$store.getters.username,
					match_date: this.dpMatchDate,
				};

				// console.log(jsonRequest);

				this.blnLoading = true;
        this.jsonResponse.success = true;

        this.$http.post(apiURL, jsonRequest).then(
          function(apiResponse) {
						// Json Response Success
						// console.log(apiResponse);

						this.blnLoading = false;

            try {
              if (apiResponse) {
                if (typeof apiResponse.data.status == "string") {
                  this.jsonResponse.success = apiResponse.data.status == "1";
                } else {
                  this.jsonResponse.success = apiResponse.data.status == 1;
								}

								this.jsonResponse.status = apiResponse.data.statusdesc;

                if (this.jsonResponse.success == true) {
                  let aryAPICompanyList = null;
                  this.aryAPICompanyList = apiResponse.data.value;
                  this.aryCompanyList = [];

                  let gloThis = this;
                  this.aryAPICompanyList.forEach((value, index) => {
                      gloThis.aryCompanyList.push({
                        label: value['name_en'],
                        value: value['comp_id'],
                        match_id: value['match_id']
                        });
                  });

                  this.fcControlForm(this.aryCompanyList.length);
                } else {
                  this.blnShowMessage = true;
                  this.strBannerClass = "cssBannerError";
                  this.strBannerMessage = this.jsonResponse.status;

                  // if (this.jsonResponse.status == "invalidToken"){
                  //   this.$helpers.handleFeedback(this.jsonResponse.status);
                  // }

                  let blnCommonResult = this.$helpers.handleFeedback(this.jsonResponse.status);
                }
              }
            } catch (error) {
              this.jsonResponse.success = false;
              this.jsonResponse.status = errorTags.request.failed;
            }
          },
          function(apiResponse) {
						// Json Response Error
            this.blnLoading = false;
            this.jsonResponse.success = false;
            this.jsonResponse.status = errorTags.request.failed;
          }
        );
      }
    },
    fcControlForm (intValue) {
      if (intValue == 0) {
        this.blnButtonDisable = true,
        this.blnDropDownListDisable = true,
        this.blnDropDownListReadOnly = true,
        this.blnMatchDateAutoFocus = true,
        this.blnCompanyListAutoFocus = false,
        this.fcClearCompanyList();
        this.$helpers.showDialog(this.$t("ui.combine.search_match_date"), this.$t("message.match_date_no_result", { fname: this.dpMatchDate }), "info");
      } else {
        this.blnButtonDisable = false,
        this.blnDropDownListDisable = false,
        this.blnDropDownListReadOnly = false,
        this.blnMatchDateAutoFocus = false,
        this.blnCompanyListAutoFocus = true,
        this.fcClearCompanyList();
        this.aryOptionsCompanyList = this.aryCompanyList;
      }
    },
    fcFilterCompanyList (strValue, update, abort) {
      if (strValue === "") {
        update(() => {
          this.aryOptionsCompanyList = this.aryCompanyList
        });
        return;
      }

      if (strValue.length < 1) {
        abort();
        return;
      }

      update(() => {
        const strSearch = strValue.toLowerCase();
        this.aryOptionsCompanyList = this.aryCompanyList.filter(list => list.label.toLowerCase().indexOf(strSearch) > -1);
      })
    },
    fcClearCompanyList () {
      this.ddlCompanyList = null;
      // this.txtFilterDataTableList = "";

      this.blnShowMessage = false;

      this.aryData = [];
      this.dicPagination.page = 1;
    },
    fcSearchMatch () {
      if ((this.ddlCompanyList == "") || (this.ddlCompanyList == null)) {
        return;
      }
      this.aryData = [];
      this.dicPagination.page = 1;

      this.fcGetDataList();
    },
    fcGetDataList () {
      let apiURL = config.matchNumberList_Company_Url();

      var jsonRequest = {
        session_token: this.$store.getters.sessionToken,
        user_id: this.$store.getters.username,
        match_id: this.ddlCompanyList.match_id,
        page_number: this.dicPagination.page,
        page_size: this.dicPagination.rowsPerPage,
      };

      // console.log(jsonRequest);

      this.blnLoading = true;
      this.jsonResponse.success = true;

      this.$http.post(apiURL, jsonRequest).then(
        function(apiResponse) {
          // Json Response Success
          // console.log(apiResponse);
          this.blnLoading = false;

          try {
            if (apiResponse) {
              if (typeof apiResponse.data.status == "string") {
                this.jsonResponse.success = apiResponse.data.status == "1";
              } else {
                this.jsonResponse.success = apiResponse.data.status == 1;
              }

              this.jsonResponse.status = apiResponse.data.statusdesc;

              if (this.jsonResponse.success == true) {
                this.aryAPIData  = apiResponse.data.value;
                if (this.aryAPIData.length > 0) {
                  this.aryData = this.aryAPIData;
                }

                this.dtMatchDate = this.dpMatchDate;
                this.dicPagination.rowsNumber = apiResponse.data.value[0]["totalrows"];
              } else {
                this.blnShowMessage = true;
                this.strBannerClass = "cssBannerError";
                this.strBannerMessage = this.jsonResponse.status;

                // if (this.jsonResponse.status == "invalidToken"){
                //   this.$helpers.handleFeedback(this.jsonResponse.status);
                // }

                let blnCommonResult = this.$helpers.handleFeedback(this.jsonResponse.status);
              }
            }
          } catch (error) {
            this.jsonResponse.success = false;
            this.jsonResponse.status = errorTags.request.failed;
          }
        },
        function(apiResponse) {
          // Json Response Error
          this.blnLoading = false;
          this.jsonResponse.success = false;
          this.jsonResponse.status = errorTags.request.failed;
        }
      )
    },
    fcRequest (props) {
      const { page, rowsPerPage, rowsNumber } = props.pagination;

      this.blnLoading = true;

      this.dicPagination.page = page;

      if (rowsPerPage === 0) {
        this.dicPagination.rowsPerPage = rowsNumber;
      }else{
        this.dicPagination.rowsPerPage = rowsPerPage;
      }

      this.blnLoading = false;

      this.fcGetDataList();
    },
    fcFormatCompanyName (strValue) {
      // if (strValue == undefined){
      //   return;
      // }

      return this.aryCompanyList.find((tblInfo) => tblInfo.match_id == strValue).label;
      // return config.aryCompanyList.find((tblInfo) => tblInfo.value == strValue) != undefined ? config.aryCompanyList.find((tblInfo) => tblInfo.value == strValue).label : "";
    },
    fcFormatDateTime (strValue) {
      // YYYY-MM-DD hh:mm:ss.SSS a
      return moment(new Date(strValue)).format('YYYY-MM-DD hh:mm:ss a');
    },
    fcAdd() {
      if ((this.ddlCompanyList == "") || (this.ddlCompanyList == null)) {
        this.$helpers.showDialog(this.$t("ui.combine.add_match_number"), this.$t("message.company_list_select"), "info");
        return;
      }

      this.blnDialogAdd = true;

      this.dataCompanyName = this.ddlCompanyList;
    },
    fcSuccessAdd: function(dicCompanyName, intRedNumber, decPool, blnBox) {
      // this.blnDialogAdd = false;

      if (this.ddlCompanyList.value != dicCompanyName.value){
        return;
      }

      let newItem = {
        match_id: dicCompanyName.match_id,
        red_num: intRedNumber,
        pool: decPool,
        bet_amount: 0,
        created_on: moment(new Date()).format('YYYY-MM-DD hh:mm:ss a'),
        updated_on: moment(new Date()).format('YYYY-MM-DD hh:mm:ss a'),
        updated_by: this.$store.getters.username
      };

      this.aryData.unshift(newItem);
    },
    fcCancelAdd: function() {
      this.blnDialogAdd = false;
    },
    fcEdit (dataRow) {
      this.blnDialogEdit = true;

      this.dataCompanyName = this.ddlCompanyList;
      this.dataRedNumber = dataRow.red_num;
      this.dataPool = dataRow.pool;
    },
    fcSuccessEdit: function(dicCompanyName, intRedNumber, decPool) {
      this.blnDialogEdit = false;

      let gloThis = this;
      this.aryData.filter(function(tblInfo) {
        if ((tblInfo.match_id == dicCompanyName.match_id) && (tblInfo.red_num == intRedNumber)) {
          tblInfo.pool = decPool;
          tblInfo.updated_on = moment(new Date()).format('YYYY-MM-DD hh:mm:ss a');
          tblInfo.updated_by = gloThis.$store.getters.username;
        }
      });

      this.$helpers.showDialog(this.$t("ui.combine.edit_match_number"), this.$t("message.success"), "success");
    },
    fcCancelEdit: function() {
      this.blnDialogEdit = false;
    },
    fcDelete (dataRow) {
      this.blnDialogDelete = true;

      this.dataCompanyName = this.ddlCompanyList;
      this.dataRedNumber = dataRow.red_num;
      this.dataPool = dataRow.pool;
    },
    fcSuccessDelete: function(dicCompanyName, intRedNumber, decPool) {
      this.blnDialogDelete = false;

      let intIndex = this.aryData.map(tblInfo => {return tblInfo.red_num}).indexOf(intRedNumber);
      this.aryData.splice(intIndex, 1);

      this.$helpers.showDialog(this.$t("ui.combine.delete_match_number"), this.$t("message.success"), "success");
    },
    fcCancelDelete: function() {
      this.blnDialogDelete = false;
    },
    fcHandleFail: function(tag, status) {
      // this.blnDialogAdd = false;
      // this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
  }
};
